import { Outlet } from 'react-router-dom';
import { SettingsTopBar } from './components/SettingsTopBar';

export function SettingsLayout() {
  return (
    <div>
      <SettingsTopBar />
      <Outlet />
    </div>
  );
}
